import { render, staticRenderFns } from "./AgeVerificationCompleteBase.vue?vue&type=template&id=1de82c68&scoped=true"
import script from "./AgeVerificationCompleteBase.vue?vue&type=script&lang=ts"
export * from "./AgeVerificationCompleteBase.vue?vue&type=script&lang=ts"
import style0 from "./AgeVerificationCompleteBase.vue?vue&type=style&index=0&id=1de82c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de82c68",
  null
  
)

export default component.exports